import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle } from "lucide-react";

const CyberEssentialsMicroCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-xl mx-auto">
            <Card>
              <CardContent className="py-12 text-center">
                <XCircle className="w-16 h-16 mx-auto text-muted-foreground mb-4" />
                <h1 className="text-2xl font-bold mb-2">Payment Cancelled</h1>
                <p className="text-muted-foreground mb-6">
                  No worries—your payment was not processed. You can return to our packages whenever you're ready.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button onClick={() => navigate("/services/cyber-essentials-micro")}>
                    Return to packages
                  </Button>
                  <Button variant="outline" onClick={() => navigate("/contact")}>
                    Get in touch
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CyberEssentialsMicroCancel;
